import { render, staticRenderFns } from "./welcome-sys-admins-only.vue?vue&type=template&id=431713ef&scoped=true&"
import script from "./welcome-sys-admins-only.vue?vue&type=script&lang=js&"
export * from "./welcome-sys-admins-only.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431713ef",
  null
  
)

export default component.exports